import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { engineService } from '@/services/engine-service';
import type { Evaluator } from '@/types/core/workflow-rule';
import type { UUID } from '@/utils/uuid';

import { engineQueryKeys } from './query-keys';

export function useFindEvaluator(
  tenantId?: UUID,
  ruleId?: UUID
): UseQueryResult<Evaluator | null, Error> {
  return useQuery<Evaluator | null, Error>({
    queryKey: engineQueryKeys.evaluatorDetail(tenantId, ruleId),
    queryFn: async () => {
      if (!tenantId || !ruleId) return null;
      return engineService.findEvaluator(tenantId, ruleId);
    },
    enabled: !!tenantId && !!ruleId,
  });
}
